import Leaderboard from "../components/leaderboard/Leaderboard";

export default function LeaderboardPage() {
  return <Leaderboard />;
}